












import { Vue, Component, Watch, Emit } from 'vue-property-decorator';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import AMSEditForm from './AMSEditForm.vue';
import request from '@/utils/request';
import { AppStore } from '@/store/modules/app';
import colors from 'vuetify/es5/util/colors';
import moment from 'moment';
import { getCustomer, createOrEdit } from '@/api/customer';
import Utils from '@/utils/utils';
interface DeliveryAddresses {
  name: string;
  regionId: number;
  address: string;
  phone: string;
  isDefault: boolean;
  region: any;
}

interface Form {
  name?: string;
  phone?: string;
  contactPerson?: string;
  sales?: Array<any>;
  beautyAdvisors?: Array<any>;
  levelId?: string;
  signDate?: string;
  contactPhone?: string;
  settlementType?: string;
  deliveryAddresses?: Array<DeliveryAddresses>;
  regionId?: number;
  address?: string;
}
@Component({
  components: {
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-edit-form': AMSEditForm
  }
})
export default class CustomerEdit extends Vue {
  valid = false;
  phonevalid = true;
  brandList = [{ id: '', name: '全部' }];
  form: Form = {
    signDate: new Date().toISOString().substr(0, 10),
    settlementType: 'AdvancePayment',
    sales: [],
    beautyAdvisors: []
  };
  breadItems = [
    {
      text: '客户管理',
      disabled: false,
      href: '/customer'
    },
    {
      text: '客户列表',
      disabled: false,
      href: '/customer'
    },
    {
      text: '修改客户信息',
      disabled: true
    }
  ];

  created() {
    let customerId = this.$route.query.id.toString();
    if (customerId) {
      this.init(customerId);
    }
  }
  init(id: string) {
    getCustomer(id.toString()).then((data: any) => {
      this.form = data;
      this.form.signDate = moment(data.signDate).format('YYYY-MM-DD');
      this.form.sales = data.sales.map((s: any) => {
        return s.staffId;
      });
      this.form.beautyAdvisors = data.beautyAdvisors.map((s: any) => {
        return s.staffId;
      });
    });
  }
  addressChange(address: any) {
    this.form.deliveryAddresses = address;
  }
  selectChange(staff: any) {
    this.form = Object.assign({}, this.form, staff);
  }
  phoneValid(value: boolean) {
    this.phonevalid = value;
  }
  save() {
    if (!this.phonevalid) {
      AppStore.ShowError('手机号已重复');
      return false;
    }
    if ((this.$refs.form as HTMLFormElement).validate()) {
      let filterDeliveryAddresses: any = [],
        error = false;

      filterDeliveryAddresses =
        this.form.deliveryAddresses &&
        this.form
          .deliveryAddresses!.map((f: DeliveryAddresses | null, index: number) => {
            for (var key of Object.keys(f!)) {
              if (!(f as any)[key]) {
                delete (f as any)[key];
              }
            }
            if (Object.keys(f!).length == 0) {
              f = null;
            } else {
              // if (f!.region) {
              //   f!.regionId = f!.region.id;
              // }
              if (!f!.name) {
                error = true;
                AppStore.ShowError('请填写收货人');
              }
              if (!f!.regionId) {
                error = true;
                AppStore.ShowError('请填写省市区');
              }
              if (f!.regionId) {
                if (!f!.address) {
                  error = true;
                  AppStore.ShowError('请填写收货详细地址');
                }
              }
              if (!f!.phone) {
                error = true;
                AppStore.ShowError('请填写手机号');
              }
              if (f!.phone && !/^1[3-9][0-9]{9}$/.test(f!.phone)) {
                error = true;
                AppStore.ShowError('手机号格式不正确');
              }
              if (this.form.deliveryAddresses!.length == 1 && index == 0) {
                f!.isDefault = true;
              }
            }
            return f;
          })
          .filter((f: any) => {
            return f;
          });
      if (this.form.regionId) {
        if (!this.form.address) {
          error = true;
          AppStore.ShowError('请填写详细地址');
        }
      }
      if (this.form.address) {
        if (!this.form.regionId) {
          error = true;
          AppStore.ShowError('请填写所属区域');
        }
      }
      if (error) return;
      let formData = Object.assign({}, this.form, {
        deliveryAddresses: filterDeliveryAddresses
      });
      createOrEdit(formData).then(data => {
        Utils.clearAllSearchPage(this.$route.name as string);
        this.$router.push({
          name: 'customer_index'
        });
      });
    }
  }
  goBack() {
    this.$router.go(-1);
  }
}
